// PolitykaPrywatnosci.jsx
import React from "react";
import { Helmet } from "react-helmet-async";

export default function PolitykaPrywatnosci() {
  return (
    <section className="bg-white text-black pt-32 pb-10 px-3 max-w-4xl mx-auto">
      <Helmet>
        <title>Polityka prywatności – DJ Kusy</title>
        <meta
          name="description"
          content="Dbam o Twoją prywatność! Sprawdź, jak bezpiecznie przetwarzam Twoje dane i dlaczego możesz mi zaufać, powierzając organizację swojego wydarzenia."
        />
        <link rel="canonical" href="https://djkusy.pl/polityka-prywatnosci" />

        {/* Breadcrumbs structured data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Strona główna",
                "item": "https://djkusy.pl/"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Polityka prywatności",
                "item": "https://djkusy.pl/polityka-prywatnosci"
              }
            ]
          })}
        </script>

        {/* WebPage structured data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Polityka prywatności",
            "url": "https://djkusy.pl/polityka-prywatnosci",
            "description": "Polityka prywatności DJ-a: jak przetwarzam dane osobowe przekazane przez formularz kontaktowy na stronie.",
            "inLanguage": "pl-PL"
          })}
        </script>
      </Helmet>

      <h1 className="text-3xl font-bold mb-8">Polityka prywatności</h1>
      <p className="mb-4">
        Korzystając z formularza kontaktowego na stronie djkusy.pl, przekazujesz dane takie jak imię, nazwisko, adres e-mail,
        numer telefonu, miejsce i data wydarzenia oraz jego charakter. Dane te służą wyłącznie do odpowiedzi na zapytanie
        i nie są nigdzie zapisywane poza skrzynką mailową.
      </p>
      <p className="mb-4">
        Administratorem danych jest DJ Filip Kusy. Masz prawo wglądu, poprawiania i żądania usunięcia danych. W tym celu
        napisz na adres <a href="mailto:biuro@djkusy.pl" className="underline">biuro@djkusy.pl</a>.
      </p>
      <p className="mb-4">
        Dane nie są udostępniane podmiotom trzecim ani nie są wykorzystywane do celów marketingowych.
      </p>
      <p className="text-sm text-zinc-500 mt-12">
        Obowiązuje od 2024. Możemy wprowadzić zmiany, które będą publikowane na tej stronie.
      </p>
    </section>
  );
}
